module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-list"
  }, [_c('div', {
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/courseList'
      }
    }
  }, [_vm._v("特色课程管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("特色课程详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main-box"
  }, [_c('Card', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("特色课程基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.showExtra,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "特色课程名称:"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.showExtra.name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "特色课程ID:"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.showExtra.id))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "特色课程图片:"
    }
  }, [(_vm.showExtra.image != '') ? _c('img', {
    attrs: {
      "src": _vm.showExtra.image,
      "width": "80px",
      "height": "80px"
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数量:"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.showExtra.count))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "级别:"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.showExtra.level))])]), _vm._v(" "), _c('br')], 1)], 1)])]), _vm._v(" "), _c('Card', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("\n          已添加书籍\n          "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("（可拖拽进行排序）")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.bookData,
      "stripe": "",
      "border": "",
      "row-key": "id",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rid",
      "label": "书籍ID",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.viewBook(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.rid))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "书籍名称",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.viewBook(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dbName",
      "label": "CP",
      "align": "center",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "品牌",
      "align": "center",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.content.brand))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updated_at",
      "label": "级别",
      "align": "center",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.content.level))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "排序",
      "align": "center",
      "width": "130",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clevel",
      "label": "上下架状态",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.clevel == 0) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("已下架")]) : _vm._e(), _vm._v(" "), (scope.row.clevel == 4) ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("审核通过")]) : _vm._e(), _vm._v(" "), (scope.row.clevel == 5) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已上架")]) : _vm._e(), _vm._v(" "), (scope.row.clevel == 2) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("编辑中")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "danger",
      "icon": "delete2"
    },
    on: {
      "click": _vm.handleDelete
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "arrow-up"
    },
    on: {
      "click": function($event) {
        return _vm.shangxiajia(5)
      }
    }
  }, [_vm._v("上架")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "icon": "arrow-down"
    },
    on: {
      "click": function($event) {
        return _vm.shangxiajia(0)
      }
    }
  }, [_vm._v("下架")])], 1)])]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "43%",
      "margin-top": "30px",
      "margin-bottom": "50px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.lastStep
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmSubmit
    }
  }, [_vm._v("确定")])], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "width": "50%",
      "text-align": "center",
      "margin": "0 auto"
    },
    attrs: {
      "title": "",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "16px",
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n      分享绘本："), _c('span', [_vm._v(_vm._s(_vm.bookName))])]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.doCopy()
      }
    }
  }, [_vm._v("\n      复制分享链接")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-693b5d41","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/course/myextra.vue
// module id = 706
// module chunks = 1